import '../ProjectPage.css';
import PageContentWrapper from '../../../components/PageContentWrapper/PageContentWrapper';
import { CreateProjectForm } from './CreateProjectForm';

const ProjectPage = () => {
  return (
    <PageContentWrapper className={'project-page-container'}>
      <CreateProjectForm />
    </PageContentWrapper>
  );
};

export default ProjectPage;
